<!-- 营业概览 -->
<template>
    <div class="container">
        <span style="font-size: 20px;">营业概览</span>
        <div class="search-box">
            <span>营业时间：</span>
            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="dateTime" type="daterange"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
            <el-button type="primary" icon="el-icon-search"
                style="margin-left: 20px;background-color: #f59a23;border: none;" @click="search">查询</el-button>
            <el-button icon="el-icon-refresh" style="margin-left: 20px;" @click="reset">重置</el-button>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="营业" name="first">
                <first ref="first" :dateTime="dateTime" />
            </el-tab-pane>
            <el-tab-pane label="收款" name="second">
                <second ref="second" :dateTime="dateTime" />
            </el-tab-pane>
            <el-tab-pane label="菜品" name="third">
                <third ref="third" :dateTime="dateTime" />
            </el-tab-pane>
            <el-tab-pane label="顾客" name="fourth">
                <fourth ref="fourth" :dateTime="dateTime" />
            </el-tab-pane>
        </el-tabs>


    </div>
</template>

<script>
import first from './components/first.vue';
import second from './components/second.vue';
import third from './components/third.vue';
import fourth from './components/fourth.vue';
// 创建一个表示当前日期的 Date 对象
let currentDate = new Date();
let currentDate2 = new Date();

// 获取当前日期的天数
let currentDay = currentDate.getDate();

// 将日期减去一天
currentDate.setDate(currentDay - 1);
currentDate2.setDate(currentDay - 1);
export default {
    name: '',
    components: {
        first,
        second,
        third,
        fourth
    },
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() >= today.getTime();
                }
            },
            dateTime: [currentDate2, currentDate],
            activeName: 'first'
        };
    },
    mounted() {
        this.$refs.first.getData()
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
            this.search()
        },
        search() {
            switch (this.activeName) {
                case 'first':
                    this.$refs.first.getData()
                    break;
                case 'second':
                    this.$refs.second.getData()
                    break;
                case 'third':
                    this.$refs.third.getData()
                    break;
                case 'fourth':
                    this.$refs.fourth.getData()
                    break;
            }
        },
        reset() {
            this.dateTime = [currentDate2, currentDate]
            this.search()
        }
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    background-color: #fff;
    padding: 20px;

    .search-box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 20px;

        span {
            font-size: 14px;
            margin-right: 10px;
        }
    }


}


/deep/ .el-tabs__active-bar {
    background-color: #f59a23;
    font-size: 16px !important;
}

/deep/ .el-tabs__item:hover {
    color: #f59a23;
    cursor: pointer;
}

/deep/ .el-tabs__item {
    color: #000;
    cursor: pointer;
}
</style>